import { useTranslation } from "react-i18next";
import { z } from "zod";

export const useAddBillPdfMethodModalSchema = () => {
  const { t } = useTranslation();

  return z.object({
    house: z.number({ required_error: t("common.form.field.errors.required") }),
    file: z.instanceof(File, {
      message: t("common.form.field.errors.required"),
    }),
  });
};

export type TAddBillPdfMethodModalSchema = z.infer<
  ReturnType<typeof useAddBillPdfMethodModalSchema>
>;
